import { getTopOrigin } from './get-top-origin';

export const getInitializationCommand = (codeChallenge: string, sessionId: string): string => {
  /* START GENAI@GHCOPILOT */

  const origin = window.location.origin;
  const topOrigin = getTopOrigin();
  const initializationObject = {
    command: {
      type: 'INITIALIZATION',
      data: {
        proof_challenge: codeChallenge,
        proof_challenge_method: 'S256',
        redirect_uri: origin,
        response_mode: 'com_visa_web_message',
        response_type: 'urn:ext:oauth:response-type:server-state',
        session_context: {
          apn: 'vdcp-web',
          client_software: {
            id: 'SRC',
            integrator_origin: origin,
            tenancy: {
              product_code: 'VXO'
            },
            top_origin: topOrigin,
            version: '24.07',

            uebas: [
              {
                source: 'VDI',
                ref: sessionId
              }
            ]
          }
        },
        settings: {
          event: {
            on_success: 'ON',
            on_failure: 'ON'
          },
          capability: {
            webauthn: 'REQUIRED',
            webauthn_options: {
              platform_attachment: 'REQUIRED',
              user_verification: 'REQUIRED'
            }
          }
        },
        web_message_target: null,
        web_message_uri: null
      }
    },
    ref: sessionId,
    ts: Date.now(),
    type: 'COMMAND'
  };

  const stringifiedCommand = JSON.stringify(initializationObject);
  const urlEncodedCommand = encodeURIComponent(stringifiedCommand);
  return urlEncodedCommand;
};

/* END GENAI@GHCOPILOT */
